import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';

import css from '../nibTable.module.sass';

const Add = ({ onClick, disableAddButton }) => {
  return (
    <div className={css.add}>
      <Button variant="contained" color="primary" onClick={onClick} disabled={disableAddButton}>
        <AddIcon color="secondary" />
      </Button>
    </div>
  );
};

export default Add;
